import CustomerDataManagementIntegrationView from 'views/UseCases/CustomerDataManagementIntegration'

const CustomerDataManagementIntegration = () => {
  return <CustomerDataManagementIntegrationView />
}

export default CustomerDataManagementIntegration
